/**
 * Adds default validation messages to the template cache to be used with gz-messages-include.
 * Unfortunately, ng-messages-include doesn't appear to work with angular-material's md-auto-hide,
 * which hides validation messages until after the user is allowed a chance to fill out the form (will need to file a defect).
 * Therefore, it is currently recommended to inline the messages and not use ng-messages-include.
 */
export const NG_MESSAGES_INCLUDE_NAME = 'gz-validation';
export default function addMessagesToInclude($templateCache) {
  'ngInject';

  let messagesMarkup = require('./messages.jade');
  $templateCache.put(NG_MESSAGES_INCLUDE_NAME, messagesMarkup);
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/validation/messages.run.js